export default __webpack_public_path__ + "img/1cbf0f5a687ce2bf55a88e98438b3ddd.svg";